import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ToastProps } from 'modules/ui/toast/Toast';

export interface ToastContainerState {
  activeToasts: ToastProps[];
}

const initialState: ToastContainerState = {
  activeToasts: [],
};

export const toastContainerSlice = createSlice({
  name: 'toastContainer',
  initialState,
  reducers: {
    addToast: (state, action: PayloadAction<ToastProps>) => {
      state.activeToasts.push(action.payload);
    },
    removeToast: (state, action: PayloadAction<string>) => {
      state.activeToasts = state.activeToasts.filter(
        (activeToast) => activeToast.id !== action.payload,
      );
    },
    clearAllToasts: (state) => {
      state.activeToasts = [];
    },
  },
});

export const { addToast, removeToast, clearAllToasts } =
  toastContainerSlice.actions;

export default toastContainerSlice.reducer;
